import styled from 'styled-components'

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
  white-space: nowrap;
`
